module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-a1c6d9f68d775da9c0637f92f5e0ec08.png";